import React, { startTransition } from 'react';
import { createPortal } from 'react-dom';
import { Sun, Activity, DollarSign, Users, Sparkles } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';
import { ROUTES } from '../../constants/routes';

const MobileBottomNav = ({ activeTab, setActiveTab, onShowSettings }) => {
  const { theme } = useTheme();

  const navItems = [
    { id: ROUTES.TODAY,   label: 'Today', icon: Sun },
    { id: ROUTES.BUILD,   label: 'Build', icon: Activity },
    { id: ROUTES.AI,      label: 'AI',    icon: Sparkles },
    { id: ROUTES.COMPANY, label: 'Money', icon: DollarSign },
    { id: ROUTES.TEAM,    label: 'Team',  icon: Users }
  ];

  const isLight = theme === 'light';

  return createPortal(
    <nav
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 99999,
        display: 'block',
        backgroundColor: isLight
          ? 'rgba(255, 255, 255, 0.82)'
          : theme === 'blue'
            ? 'rgba(15, 23, 42, 0.72)'
            : 'rgba(8, 10, 14, 0.72)',
        borderTop: isLight
          ? '1px solid var(--card-border, rgba(0, 0, 0, 0.06))'
          : '1px solid var(--card-border, rgba(255, 255, 255, 0.06))',
        backdropFilter: 'saturate(180%) blur(24px)',
        WebkitBackdropFilter: 'saturate(180%) blur(24px)',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around', height: '48px', padding: '0 12px' }}>
        {navItems.map((item) => {
          const isActive = activeTab === item.id;
          const Icon = item.icon;

          return (
            <button
              key={item.id}
              onClick={() => startTransition(() => setActiveTab(item.id))}
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                flex: 1,
                padding: '2px 0',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                color: isActive
                  ? isLight ? '#059669' : '#34d399'
                  : isLight ? 'rgba(0,0,0,0.35)' : 'rgba(255,255,255,0.4)',
                transition: 'color 0.2s ease, transform 0.15s ease',
                WebkitTapHighlightColor: 'transparent',
              }}
            >
              <Icon
                size={18}
                strokeWidth={isActive ? 2.2 : 1.5}
                style={{ transition: 'transform 0.15s ease', transform: isActive ? 'scale(1.05)' : 'scale(1)' }}
              />
              <span
                style={{
                  fontSize: '9.5px',
                  letterSpacing: '0.03em',
                  lineHeight: 1,
                  marginTop: '3px',
                  fontWeight: isActive ? 600 : 500,
                  opacity: isActive ? 1 : 0.7,
                  textTransform: 'uppercase',
                  fontFamily: '-apple-system, BlinkMacSystemFont, "Inter", "Segoe UI", sans-serif',
                }}
              >
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
      {/* Safe area for notched devices */}
      <div style={{ height: 'env(safe-area-inset-bottom, 0px)' }} />
    </nav>,
    document.body
  );
};

export default MobileBottomNav;
